import { all } from 'redux-saga/effects'
import agendamento from './modules/agendamento/sagas'
import colaboradores from './modules/colaboradores/sagas'

export default function* rootSaga() {
    return yield all([agendamento, colaboradores])
}